import { i18n } from '@/plugins/vue-i18n'

export const MOBILE_URLS = {
  DOCUMENTS: i18n.t('routes.mobile.documents').toString(),
  EXPEDIENTS: i18n.t('routes.mobile.expedients').toString(),
  EXPEDIENT_DETAIL: i18n.t('routes.mobile.expedient_detail').toString(),
  HOME: i18n.t('routes.mobile.home').toString()
}
